// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"7f036da1","114":"d9245317","717":"472e6cfe"}[chunkId] + ".chunk.js";
};